module.exports = __webpack_public_path__ + "img/tooltip_14-vallone-litho-calce-grigio-tremezzo-02.04e50596.jpg";